module.exports = __webpack_public_path__ + "static/media/McGill.d4b05f63.png";